import connection from "@/api/connection";

// export const singIn = async ({ commit }, user) => {
//     tr
// }

export const getOutputs = async ({ commit }) => {
  let url = `/outputs/selectable`;

  await connection
    .get(url)
    .then((res) => {
      const outputs = res.data.data;
      commit("setOutputsSelectable", outputs);
    })
    .catch((err) => {
      console.log("error", err);
    });
};

export const loadOutputs = async ({ commit }, query = null) => {
  let page = 1;
  let search = "";
  let perPage = 25;
  if (query !== null) {
    page = query?.page || 1;
    search = query?.search || "";
    perPage = query?.perPage || 25;
  }

  commit("setOutputIsLoading", true);
  let url = `/outputs`;
  if (search === "") {
    url = `${url}?page=${page}&perPage=${perPage}&status=pending`;
  } else {
    url = `${url}?search=${search}&page=${page}&perPage=${perPage}&status=pending`;
  }

  await connection
    .get(url)
    .then((res) => {
      const outputs = res.data.data;
      console.log(outputs);
      commit("setOutputs", outputs);
      const pagination = {
        totalItems: res.data.totalItems, // total number of elements or items
        // per_page: res.data.per_page, // items per page
        currentPage: res.data.currentPage, // current page (it will be automatically updated when users clicks on some page number).
        totalPages: res.data.totalPages, // total pages in record

        perPage: res.data.perPage,
      };
      res.data.pagination = pagination;
      commit("setOutputsPaginated", res.data);
      commit("setOutputIsLoading", false);
    })
    .catch((err) => {
      console.log("error", err);
      commit("setOutputIsLoading", false);
    });
};

export const outputById = async ({ commit }, id) => {
  commit("setOutputIsLoading", true);
  await connection
    .get(`/outputs/${id}`)
    .then((res) => {
      commit("setOutputDetail", res.data.data);
      commit("setOutputIsLoading", false);
    })
    .catch((err) => {
      console.log("error", err);
      commit("setOutputIsLoading", false);
    });
};

export const storeOutput = async ({ commit }, output) => {
  commit("setOutputIsCreating", true);
  await connection
    .post(`/outputs/create`, output)
    .then((res) => {
      commit("saveNewOutputs", res.data);
      commit("setOutputIsCreating", false);
    })
    .catch((err) => {
      console.log("error", err);
      commit("setOutputIsCreating", false);
    });
};

export const updateOutput = async ({ commit }, output) => {
  commit("setOutputIsUpdating", true);
  await connection
    .put(`/outputs/${output.id}/update`, output)
    .then((res) => {
      commit("saveUpdatedOutput", res.data);
      commit("setOutputIsUpdating", false);
    })
    .catch((err) => {
      console.log("error", err);
      commit("setOutputIsUpdating", false);
    });
};

export const deleteOutput = async ({ commit }, output) => {
  commit("setOutputIsDeleting", true);
  await connection
    .delete(`/outputs/${output.id}/cancel`)
    .then((res) => {
      commit("setDeleteOutput", res.data);
      commit("setOutputIsDeleting", false);
    })
    .catch((err) => {
      console.log("error", err);
      commit("setOutputIsDeleting", false);
    });
};

export const cancelOutput = async ({ commit }, input) => {
  commit("setOutputIsCancelating", true);
  await connection
    .post(`/outputs/cancel`, input)
    .then((res) => {
      commit("setCancelOutput", res.data);
      commit("setOutputIsCancelating", false);
    })
    .catch((err) => {
      console.log("error", err);
      commit("setOutputIsCancelating", false);
    });
};
